import lazySizes from 'lazysizes';

import Collapse from 'bootstrap/js/dist/collapse.js';

import Dropdown from 'bootstrap/js/dist/dropdown.js';

import Popper from 'popper.js/dist/popper.js';

export const init = () => {
    import(/* webpackMode: "eager" */ './fontawesome.js');

    import(/* webpackMode: "eager" */ './events.js');

    if(document.getElementsByClassName('carousel').length > 0 ) {
        import(
            /* webpackMode: "eager" */ 
            './carousel.js').then(carousel => carousel.init());
    }
}